import React, { useState, useEffect } from "react";
import { marked } from "https://cdn.jsdelivr.net/npm/marked/lib/marked.esm.js";
import $ from "jquery";
import "../styles/global.css";
//import supabase from '../supabaseClient';
import { useUser } from "../hooks/useUser";
import OpenAI from "openai";
import { type } from "os";

class ChatHistoryItem {
  //role and message
  constructor(role, message) {
    this.role = role;
    this.message = message;
  }
}

function showRandomHint() {
  const hints = [
    "<i> Leaf </i> it to me to answer your question! 🌿 ",
    "I'm <i>rooting</i> for you! 🌱",
    "I'm <i>branching</i> out to answer your question! 🌳",
    "What <i> wood </i> your adventure be today? 🌲",
    "Tell me about what you’re <i> dew- </i> ing today! 🌼",
    "<i> Branch </i> out of your comfort zone! 🌿",
  ];
  const hint = hints[Math.floor(Math.random() * hints.length)];
  return hint;
}
function setChatButtonDisabled(t) {
  document.getElementById("chatBtn").disabled = t;
}
function showSystemMessage(message) {
  const chatContainer = document.getElementById("chatContainer");
  let systemMessage = document.createElement("p");
  systemMessage.className = "chat-message";
  systemMessage.innerHTML = message;
  chatContainer.appendChild(systemMessage);
}
//remove the last message from the chat container
function removeLastMessage() {
  const chatContainer = document.getElementById("chatContainer");
  chatContainer.removeChild(chatContainer.lastChild);
}

//clear all messages from the chat container
function clearChat() {
  const chatContainer = document.getElementById("chatContainer");
  chatContainer.innerHTML = "";
}

//
async function getResponse(question, username, chatThread, setChatThread) {
  //API key
  const OPENAI_API_KEY =
    "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";
  const WEATHER_API_KEY = "9f4d80699da0439da08214417242210";
  const openai = new OpenAI({
    apiKey: OPENAI_API_KEY,
    dangerouslyAllowBrowser: true,
  }); //
  const ASSSISTANT_ID = "asst_k2Lha0RNBc4oRCiLL8nNNaeo";
  if (chatThread === null) {
    chatThread = await openai.beta.threads.create();
    setChatThread(chatThread);
  }
  const message = await openai.beta.threads.messages.create(chatThread.id, {
    role: "user",
    content: question,
  });
  let run = await openai.beta.threads.runs.createAndPoll(chatThread.id, {
    assistant_id: ASSSISTANT_ID,
    instructions: "Please address the user as " + username,
  });
  if (run.status === "completed") {
    const messages = await openai.beta.threads.messages.list(run.thread_id);
    clearChat();
    for (const message of messages.data.reverse()) {
      setChatButtonDisabled(false);
      createMessage(
        new ChatHistoryItem(
          message.role === "user" ? username : "NÄTUR",
          message.role === "user"
            ? message.content[0].text.value
            : marked.parse(message.content[0].text.value)
        )
      );
      //console.log(`${message.role} > ${message.content[0].text.value}`);
    }
    scroolDown();
  } else {
    console.log(run.status);
    //if the status is action_required, the user needs to provide more information
    if (
      run.status === "requires_action" &&
      run.required_action.type === "submit_tool_outputs"
    ) {
      const functionObj = run.required_action.submit_tool_outputs.tool_calls[0];
      startToolOutput(
        functionObj.function.name,
        functionObj.function.arguments,
        functionObj.id
      );
    }
  }

  function startToolOutput(toolOutput, args, callId) {
    if (toolOutput === "get_location") {
      getLocation(callId);
    } else if (toolOutput === "get_weather") {
      getWeather(args.q, callId);
    } else if (toolOutput === "get_nearby") {
      getNearby(args, callId);
    } else if (toolOutput === "get_current_datetime") {
      getCurrentTimeDate(callId);
    }
  }

  function getNearby(args, callId) {
    if (typeof args === "string") {
      args = JSON.parse(args);
    }
    // "https://maps.googleapis.com/maps/api/place/nearbysearch/json"
    //args will contains the parameters for the nearby search, such as latitude, longitude, and radius. simply pass the jsonobject to the query string
    const url =
      "https://album.icytools.cn/fwd.php?" +
      jsonToQueryString(args) +
      "&key=AIzaSyCczeTeYhxhJo-BPa3A0ohg2q6lOM3MopQ";
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        submitToolOutputs(data, callId, "get_nearby");
      })
      .catch((error) => {
        console.error("Error:", error);
        submitToolOutputs(
          { error: "An error occurred while fetching the nearby data." },
          callId,
          "get_nearby"
        );
      });
  }

  async function submitToolOutputs(toolOutputs, callId, name) {
    const run_ = await openai.beta.threads.runs.submitToolOutputs(
      chatThread.id,
      run.id,
      {
        tool_outputs: [
          {
            tool_call_id: callId,
            output:
              typeof toolOutputs === "object"
                ? JSON.stringify(toolOutputs)
                : toolOutputs,
          },
        ],
      }
    );
    //poll the run
    const run2 = await openai.beta.threads.runs.poll(chatThread.id, run.id);
    if (run2.status === "completed") {
      const messages = await openai.beta.threads.messages.list(run2.thread_id);
      clearChat();
      for (const message of messages.data.reverse()) {
        setChatButtonDisabled(false);
        createMessage(
          new ChatHistoryItem(
            message.role === "user" ? username : "NÄTUR",
            message.role === "user"
              ? message.content[0].text.value
              : marked.parse(message.content[0].text.value)
          )
        );
        //console.log(`${message.role} > ${message.content[0].text.value}`);
      }
      scroolDown();
    } else {
      console.log(run2.status);
      //if the status is action_required, the user needs to provide more information
      if (
        run2.status === "requires_action" &&
        run2.required_action.type === "submit_tool_outputs"
      ) {
        const functionObj =
          run2.required_action.submit_tool_outputs.tool_calls[0];
        startToolOutput(
          functionObj.function.name,
          functionObj.function.arguments,
          functionObj.id
        );
      }
    }
  }

  function getWeather(q, callId) {
    const url =
      "https://api.weatherapi.com/v1/current.json?key=" +
      WEATHER_API_KEY +
      "&q=" +
      q;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        submitToolOutputs(data, callId, "get_weather");
      })
      .catch((error) => {
        console.error("Error:", error);
        submitToolOutputs(
          { error: "An error occurred while fetching the weather data." },
          callId,
          "get_weather"
        );
      });
  }

  function getCurrentTimeDate(callId) {
    const date = new Date();
    const time = date.toLocaleTimeString();
    const day = date.toLocaleDateString();
    const currentTime = "The current time is " + time + " on " + day + ".";
    submitToolOutputs({ time: currentTime }, callId, "get_current_datetime");
  }

  //get the location of the user
  function getLocation(callId) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
        const location = "Latitude: " + lat + " Longitude: " + lon;
        submitToolOutputs({ location: location }, callId, "get_location");
      });
    } else {
      submitToolOutputs(
        {
          error:
            "Geolocation is not supported by this browser, or permission denied.",
        },
        callId,
        "get_location"
      );
      //showSystemMessage("Geolocation is not supported by this browser.");
    }
  }

  //json to query string
  function jsonToQueryString(json) {
    return Object.keys(json)
      .map((key) => {
        const value = json[key];
        // Encode both the key and the value to handle special characters
        return encodeURIComponent(key) + "=" + encodeURIComponent(value);
      })
      .join("&");
  }
}

function createMessage(messageItem) {
  const chatContainer = document.getElementById("chatContainer");
  let message = document.createElement("p");
  message.className = "chat-message";
  message.innerHTML = messageItem.role + ": " + messageItem.message;
  chatContainer.appendChild(message);
}
function scroolDown() {
  // Select the element you want to scroll
  const element = document.getElementById("chatContainer");

  // Scroll to the bottom
  element.scrollTop = element.scrollHeight;
}

function Chat() {
  //const [question, setQuestion] = useState("");
  //const [chatHistory, setChatHistory] = useState([]);
  const [chatThread, setChatThread] = useState(null);
  const { user, loading } = useUser();
  if (!user && !loading) {
    window.location.href = "/login";
  }
  //getResponse("What is the capital of France?");

  //const [chatVisible, setChatVisible] = useState(false);
  function handleInputChange(event) {
    const input = document.getElementById("questionInput").value;
    const chatBtn = document.getElementById("chatBtn");
    if (input.trim() !== "") {
      $(chatBtn).fadeIn("slow");
    } else {
      $(chatBtn).fadeOut("slow");
    }
  }

  const showChatInterface = () => {
    //setChatVisible(true);
  };

  function sendChatMessage() {
    const input = document.getElementById("questionInput").value;
    const chatContainer = document.getElementById("chatContainer");
    //chatContainer.style.display = 'block';
    $("#chatContainer").fadeIn("slow");
    const chatHistoryItem = new ChatHistoryItem(user.full_name, input);
    //disable the chat button
    setChatButtonDisabled(true);
    createMessage(chatHistoryItem);
    document.getElementById("questionInput").value = "";
    getResponse(input, user.full_name, chatThread, setChatThread);
    //chatContainer.style.display = 'block';
    showSystemMessage("Nätur is typing...");

    scroolDown();
  }

  useEffect(() => {
    // Dynamically load the external script
    const script = document.createElement("script");
    script.src = "js/chatinterface.js";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const formOnSubmit = (event) => {
    event.preventDefault();
    sendChatMessage();
  };

  return (
    //apply the styles from the chat.module.css file
    //to the elements in the chat component

    <>
      <div className="navbar">
        <img
          src="icons/icon_person.png"
          alt="Profile"
          className="profile-icon"
        />{" "}
        &nbsp;&nbsp;&nbsp;
        <a href="/home" className="logout navbar-item">
          Home
        </a>
        &nbsp;&nbsp;&nbsp;
        <a href="/logout" className="logout navbar-item">
          Logout
        </a>
      </div>
      <div className="container">
        <style>
          {`
body
{
    backdrop-filter: blur(10px);
}
.chat-btn {
    display: none;
    background-color: white;
    color: black;
    border: none;
    width: 100%;
    margin-top: 10px;
}

.chat-btn:hover {
    background-color: #f1f1f1;
    color:black;
}
    .chat-btn:disabled {
                    
    background-color: #f1f1f1;  
    color: black;
}


.chat-container {
                display: none;
    background: rgba(255, 255, 255, 0.9);
    color: black;
    border-radius: 15px;
    padding: 20px;
    margin-top: 20px;
    height: 300px;
    overflow-y: auto;
    text-align: left;
}
    body{flex-direction: column; align-items: stretch; }
`}
        </style>
        <h1>NÄTUR</h1>
        <p
          id="randomHint"
          dangerouslySetInnerHTML={{ __html: showRandomHint() }}
        ></p>
        <form onSubmit={formOnSubmit}>
          <input
            type="text"
            className="form-control"
            id="questionInput"
            placeholder="Ask nätur a question"
            onChange={handleInputChange}
          />
          <button type="submit" className="btn chat-btn" id="chatBtn">
            Send
          </button>
        </form>
        <div className="chat-container" id="chatContainer"></div>
      </div>
    </>
  );
}

export default Chat;
